import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '@styles/App.less';
import { selectUserInfo, setUserInfo } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';
import AppHeader from '@components/app/appHeader';
import AppOperate from '@components/app/appOperate';
import MenuMask from '@components/dialog/menuMask';
import TryOutDialog from '@components/dialog/tryOutDialog';
import Home from '@views/home';
import Introduce from '@views/introduce';

//import Support from '@views/support';
//import About from '@views/about';
//import Buy from '@views/buy';
import CSD from '@views/civilstationdesigner';
import Bentleproduct from '@views/bentleproduct';
import Digitaltwin from '@views/digitaltwin';
import Login from '@views/login';
import KsjSpace from '@views/ksjspace';
import AboutKsj from '@views/aboutksj';
import CSC from '@views/civilstationconstru';
import VisualReview from '@views/visualreview';
import NewOne from '@views/newone';
import NewTwo from '@views/newtwo';
import NewThree from '@views/newthree';

import MunicipalRoadBridge from '@views/1+xMunicipalRoadBridge';
import AppCollegeSoftwareSupport from '@views/collegeSoftwareSupport';

//import civilstationconstru from '@views/civilstationconstru';
const App = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const userInfo = useSelector(selectUserInfo);
  const localUserInfo = localStorage.getItem('userInfo');
  const needAuthPathList = ['/login', '/buy'];

  // 获取 userInfo 并且保存到 redux
  if (localUserInfo && !userInfo.jwt) {
    dispatch(setUserInfo(JSON.parse(localUserInfo)));
  }

  // 需要登录才能查看的页面，未登录状态重定向到登录页面
  if (!localUserInfo && needAuthPathList.includes(pathname)) {
    return (
      <div className="app">
        <Switch>
          <Route exact path={'/login'} component={Login} />
          <Redirect to={'/login'} />
        </Switch>
      </div>
    );
  }

  return (
    <div className="app">
      <AppHeader />

      <Switch>
        <Redirect from={'/login'} to={'/'} />
        <Route exact path={'/'} component={Home} />
        <Route exact path={'/introduce'} component={Introduce} />
        {/*  <Route exact path={'/support'} component={Support} /> */}
        <Route exact path={'/visualreview'} component={VisualReview} />
        <Route exact path={'/civilstationconstru'} component={CSC} />
        <Route exact path={'/aboutksj'} component={AboutKsj} />
        <Route exact path={'/ksjspace'} component={KsjSpace} />
        <Route exact path={'/civilstationdesigner'} component={CSD} />
        <Route exact path={'/bentleproduct'} component={Bentleproduct} />
        <Route exact path={'/digitaltwin'} component={Digitaltwin} />
        <Route exact path={'/newone'} component={NewOne} />
        <Route exact path={'/newtwo'} component={NewTwo} />
        <Route exact path={'/newthree'} component={NewThree} />
        
        <Route exact path={'/municipalRoadBridge'} component={MunicipalRoadBridge} />
        <Route exact path={'/collegeSoftwareSupport'} component={AppCollegeSoftwareSupport} />

      </Switch>

      <AppOperate />

      {/* 全局的菜单遮罩层 */}
      <MenuMask />

      {/* 申请试用 */}
      <TryOutDialog />
    </div>
  );
};

export default App;
